import { serverUrl, getDefaultHeaders } from 'services/authService';
import { CarrierConnectionConfig } from 'models/CarrierConnectionConfig';

const getCarrierDisplayName = (
  carrierName: string,
  carrierConnectionConfig: CarrierConnectionConfig[],
): string => {
  if (!carrierName) return '';
  const carrier = carrierConnectionConfig.find((config) => config.name === carrierName);
  if (!carrier) return carrierName;
  return carrier.display_name || carrier.name;
};

// Get required fields for a specific carrier
const getCarrierRequiredFields = (carrierName: string, carrierConnectionConfig: CarrierConnectionConfig[]) => {
  const carrier = carrierConnectionConfig.find(config => config.name === carrierName);
  
  if (!carrier) {
    console.warn(`Carrier "${carrierName}" not found in connection config`);
    return [];
  }
  
  return carrier.connection_config?.required_fields || [];
};

const getCarrierUserInstruction = (carrierName: string, carrierConnectionConfig: CarrierConnectionConfig[]) => {
  const carrier = carrierConnectionConfig.find(config => config.name === carrierName);

  if (!carrier) {
    return '';
  }

  return (
    carrier.user_instruction
    || ''
  );
};

/** Human-readable label for a snake_case connection field key (e.g. remote_directory → Remote Directory). */
const formatConnectionFieldLabel = (fieldName: string) =>
  fieldName.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());

/**
 * Default values from connection_config.defaults for the selected carrier.
 * Fields listed here may be shown as optional with the default as placeholder.
 */
const getCarrierConnectionDefaults = (
  carrierName: string,
  carrierConnectionConfig: CarrierConnectionConfig[],
): Record<string, string> => {
  const carrier = carrierConnectionConfig.find((config) => config.name === carrierName);
  if (!carrier) return {};
  const defaults = carrier?.connection_config?.defaults;
  if (!defaults || typeof defaults !== 'object') return {};
  const result: Record<string, string> = {};
  for (const [key, value] of Object.entries(defaults)) {
    if (value !== null && value !== undefined && String(value).length > 0) {
      result[key] = String(value);
    }
  }
  return result;
};

const getCarrierConnectionConfig = async (accessToken: string) => {
    const response = await fetch(`${serverUrl}/carrier_connection_config`, {
      headers: getDefaultHeaders(accessToken),
    });
  
    if (!response.ok) {
      throw new Error('Failed to fetch carrier connection config');
    }
  
    const data = await response.json();
    return data;
  };

export {
    getCarrierConnectionConfig,
    getCarrierDisplayName,
    getCarrierRequiredFields,
    getCarrierUserInstruction,
    getCarrierConnectionDefaults,
    formatConnectionFieldLabel,
};
